import React, { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { Instances, Instance } from '@react-three/drei';

export default function SpaceTransition() {
  const groupRef = useRef();
  const count = 40;

  const asteroids = useMemo(() => {
    return Array.from({ length: count }).map(() => ({
      position: [
        (Math.random() - 0.5) * 40,
        (Math.random() - 0.5) * 20,
        (Math.random() - 0.5) * 20
      ],
      scale: 0.1 + Math.random() * 0.5,
      rotation: [
        Math.random() * Math.PI,
        Math.random() * Math.PI,
        Math.random() * Math.PI
      ],
      rotationSpeed: [
        (Math.random() - 0.5) * 0.5,
        (Math.random() - 0.5) * 0.5,
        (Math.random() - 0.5) * 0.5
      ]
    }));
  }, [count]);

  useFrame((state, delta) => {
    if (groupRef.current) {
      groupRef.current.children.forEach((child, i) => {
        child.rotation.x += delta * asteroids[i].rotationSpeed[0];
        child.rotation.y += delta * asteroids[i].rotationSpeed[1];
        child.rotation.z += delta * asteroids[i].rotationSpeed[2];
      });
    }
  });

  return (
    <group position={[0, 2, 0]}>
      <Instances limit={count}>
        <dodecahedronGeometry args={[1, 0]} />
        <meshStandardMaterial color="#555555" roughness={0.7} metalness={0.3} />
        <group ref={groupRef}>
          {asteroids.map((ast, i) => (
            <Instance 
              key={i} 
              position={ast.position} 
              scale={ast.scale} 
              rotation={ast.rotation} 
            />
          ))}
        </group>
      </Instances>
    </group>
  );
}
